import { EndPoints } from '../../api-config';
import * as R from 'ramda';
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const userlettersToPrintUrl = (urlSearchParams) => `${SERVER_ADDR_V1}/userletter/print/list` + (!R.isNil(urlSearchParams) ? `?${urlSearchParams.toString()}` : '');
export const getUserByIdUrl = (userId) => `${SERVER_ADDR_V1}/user/${userId}`;
export const getLetterByIdUrl = (letterId) => `${SERVER_ADDR_V1}/letter/${letterId}`;
export const letterContentUrlByletterId = (letterId) => `${SERVER_ADDR_V1}/userletter/${letterId}/content`;

export const letterAndRecoContentUrl = () => `${SERVER_ADDR_V1}/userletter/print/content`;
export const generateBoredereauUrl = () => `${SERVER_ADDR_V1}/userletter/print/validate`;


